import Vue from 'vue'
// initial state
const state = {
    stockWorth: '',
    ordersQTY: '',
    profit: '',
    incoming: '',
    today: ''
}
// getters
const getters = {
    stockWorth: state => state.stockWorth,
    profit: state => state.profit,
    ordersQTY: state => state.ordersQTY,
    incoming: state => state.incoming,
   
}



const actions = {
    //COPIA IL VALORE DEL MAGAZZINO NEL NODO GIORNALIERO
    //VIENE RICHIAMATA SOLO ALL'AVVIO DELL'APP ED ESEGUE SOLO SE NODO NON PRESENTE.
    //SERVE PER SALVARE I DATI NECESSARI PER COSTRUIRE LA CURVA DEL VALORE MAGAZZINO
    copyStockValue({ commit, state, getters }, payload) {
        let self = this
        var ref = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + 'stats' + '/' + state.today
        this.databaseOps.db.ref(ref).child('stockWorth').once('value', function (snapshot) {
            if (!snapshot.val()) {
                self.databaseOps.db.ref(ref).child('stockWorth').set(state.stockWorth)
            }

        });
    },
    //QUESTE TRE SEGUENTI AZIONI POSSONO ESSERE RIDOTTE A UNA SOLA IN QUANTO TUTTE UGUALI,
    //CAMBIA SOLO IL CHILD CHE LEGGONO E RELATIVO STATO CHE AGGIORNANO.
    getOrdersQTY({ commit, state, getters }, payload) {
        var ref = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + 'stats' + '/' + state.today
        this.databaseOps.db.ref(ref).child('orders').on('value', function (snapshot) {
            state.ordersQTY = snapshot.val()
        });
    },
    getProfit({ commit, state, getters }, payload) {
        var ref = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + 'stats' + '/' + state.today
        this.databaseOps.db.ref(ref).child('profit').on('value', function (snapshot) {
            state.profit = snapshot.val()
        });
    },

    getIncoming({ commit, state, getters }, payload) {
        var ref = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + 'stats' + '/' + state.today
        this.databaseOps.db.ref(ref).child('incoming').on('value', function (snapshot) {
            state.incoming = snapshot.val()
        });
    },
    getStockWorth({ commit, state, getters }, payload) {
        return new Promise((resolve, reject) => {
            var ref = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + 'stats' + '/'
            this.databaseOps.db.ref(ref).child('stockWorth').on('value', function (snapshot) {
                state.stockWorth = snapshot.val()
                resolve()
            });
        })
    }

}
// mutations
const mutations = {
    getToday(state) {
        //IN FORMATO DDMMYYYY
        let data = new Date()
        state.today = ("0" + data.getDate().toString()).slice(-2) + ("0" + (data.getMonth() + 1).toString()).slice(-2) + data.getFullYear().toString()
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
